var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMegacircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5615 0C39.6746 0 51.123 11.4431 51.123 25.5615C51.123 39.68 39.68 51.123 25.5615 51.123C11.4431 51.123 0 39.6746 0 25.5615C0 11.4484 11.4431 0 25.5615 0Z",
    fill: "url(#paint0_linear_3548_73082)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5089 38.7885C40.6357 38.7885 48.8984 30.5205 48.8984 20.399C48.8984 10.2775 40.6357 1.98804 30.5089 1.98804C20.3821 1.98804 12.1033 10.2507 12.1033 20.3936C12.1033 30.5366 20.3713 38.7831 30.5089 38.7831V38.7885Z",
    fill: "url(#paint1_linear_3548_73082)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6034 49.1354C30.7302 49.1354 38.9929 40.8674 38.9929 30.7459C38.9929 20.6245 30.7249 12.335 20.6034 12.335C10.4819 12.335 2.20856 20.603 2.20856 30.7405C2.20856 40.8781 10.4604 49.13 20.598 49.13L20.6034 49.1354Z",
    fill: "url(#paint2_linear_3548_73082)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6077 12.335C18.0183 12.335 15.5524 12.8776 13.3121 13.85C12.5331 15.8861 12.1033 18.0887 12.1033 20.3934C12.1033 30.5203 20.3713 38.7829 30.5089 38.7829C33.093 38.7829 35.5535 38.2403 37.7884 37.2733C38.5674 35.2425 38.9972 33.0399 38.9972 30.7405C38.9972 20.5976 30.7292 12.335 20.6077 12.335Z",
    fill: "#FF6900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.569 36.8324C31.7687 36.8324 36.8401 31.761 36.8401 25.5613C36.8401 19.3616 31.7687 14.3063 25.569 14.3063C19.3693 14.3063 14.314 19.3616 14.314 25.5613C14.314 31.761 19.3693 36.8324 25.569 36.8324Z",
    fill: "url(#paint3_radial_3548_73082)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3548_73082",
    x1: 24.5085,
    y1: 22.8109,
    x2: 16.6811,
    y2: 2.39068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3548_73082",
    x1: 12.3666,
    y1: 20.3883,
    x2: 49.167,
    y2: 20.3883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF6900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FF6900",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF6900",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FF6900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3548_73082",
    x1: 38.9929,
    y1: 30.7352,
    x2: 2.20856,
    y2: 30.7352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF6900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FF6900",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF6900",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FF6900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3548_73082",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6027 21.8383) scale(11.2604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegacircle);
export default __webpack_public_path__ + "static/media/megacircle.0905bf6584333898df10ef8f5f938bc9.svg";
export { ForwardRef as ReactComponent };